@if (!activeQuestionnaireScreen) {
<div class="profile-container">
  <app-patients-header [isComingFromInPatient]="!!eocID" />
  <div class="patient-profile-container">
    <nz-layout class="inner-layout">
      <nz-sider nzWidth="15%" [nzCollapsed]="isCollapsed">
        <ul nz-menu nzMode="inline" class="sider-menu">
          @for (m of this.menuData?.childModules; track m) {
            @if (m.childModules.length < 1) {
              <li
                nz-menu-item
                [ngClass]="{
                  'single-menu': componentPaths.pilotStudy != m.path,
                  'single-menu-collapse': isCollapsed,
                  '': !isCollapsed,
                  'pilot-study': componentPaths.pilotStudy == m.path,
                }"
                [nzSelected]="m.path == selectedOption"
                (click)="clickItem(m)"
              >
                @if (componentPaths.pilotStudy != m.path) {
                  <span
                    nz-icon
                    [nzType]="'icons:' + m.icon"
                    [ngClass]="{
                      'single-menu-icon': isCollapsed,
                      'single-menu-icon-nc': !isCollapsed,
                    }"
                  ></span>
                }
                <span
                  [ngClass]="{ 'label-single': isCollapsed, '': !isCollapsed }"
                  >{{ m.name | translate }}</span
                >
              </li>
            }
            @if (m.childModules.length >= 1) {
              <li
                nz-submenu
                [nzOpen]="false"
                [nzTitle]="m.name | translate"
                nzIcon="icons:{{ m.icon }}"
              >
                <ul>
                  @for (option of m.childModules; track option) {
                    <li
                      nz-menu-item
                      [nzSelected]="option.path == selectedOption"
                      (click)="
                        updateSelectedOption(option.path);
                        scrollToSection(option.path)
                      "
                    >
                      {{ option.name | translate }}
                      @if (
                        option.childModules && option.childModules.length > 0
                      ) {
                        <ul>
                          @for (
                            subOption of option.childModules;
                            track subOption
                          ) {
                            <li
                              nz-menu-item
                              [nzSelected]="subOption.path == selectedOption"
                              (click)="
                                updateSelectedOption(subOption.path);
                                scrollToSection(subOption.path)
                              "
                            >
                              {{ subOption.name | translate }}
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              </li>
            }
          }
        </ul>
      </nz-sider>
      <nz-content
        [ngClass]="isCollapsed ? 'inner-content-collapse' : 'inner-content'"
      >
        <button nz-button class="collapse-menu" (click)="toggleCollapsed()">
          @if (!isCollapsed) {
            <mat-icon class="collapse-menu-icon">keyboard_arrow_left</mat-icon>
          }
          @if (isCollapsed) {
            <mat-icon class="collapse-menu-icon">keyboard_arrow_right</mat-icon>
          }
        </button>
        <!-- <button mat-fab class="collapse-menu" (click)="toggleCollapsed()">
        <mat-icon *ngIf="!isCollapsed" class="collapse-menu-icon">keyboard_arrow_left</mat-icon>
        <mat-icon *ngIf="isCollapsed" class="collapse-menu-icon">keyboard_arrow_right</mat-icon>
      </button> -->

        <app-admission-profile
          [canNavigateBackInput]="true"
          [patientIdInput]="this.patientID"
          [showPatientInformation]="showPatientInformation"
        ></app-admission-profile>

        @if (activeSubmenu() == componentPaths.ips) {
          <app-ips-section [submenu]="getSubmenu(componentPaths.ips)" />
        }

        @if (activeSubmenu() == componentPaths.alerts) {
          <app-alerts-section
            [submenu]="getSubmenu(componentPaths.alerts)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.somatometrics) {
          <app-somatometrics-section
            [submenu]="getSubmenu(componentPaths.somatometrics)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.dailyMonitoring) {
          <app-daily-monitoring-section
            [submenu]="getSubmenu(componentPaths.dailyMonitoring)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.medicalProblems) {
          <app-medical-problems-section
            [submenu]="getSubmenu(componentPaths.medicalProblems)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.medicalHistorySection) {
          <app-medical-history-section
            [submenu]="getSubmenu(componentPaths.medicalHistorySection)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (selectedOption == componentPaths.hysteroscopy) {
          <app-hysteroscopy-section
            [submenu]="getGynecologySubMenu(componentPaths.hysteroscopy)"
          />
        }

        @if (selectedOption == componentPaths.pregnancy) {
          <app-pregnancy-section
            [submenu]="getGynecologySubMenu(componentPaths.pregnancy)"
          />
        }

        @if (activeSubmenu() == componentPaths.medicationSummary) {
          <app-medication-summary-section
            [submenu]="getSubmenu(componentPaths.medicationSummary)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.socialHistory) {
          <app-social-history-section
            [submenu]="getSubmenu(componentPaths.socialHistory)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.laboratory) {
          <app-laboratory-section
            [submenu]="getSubmenu(componentPaths.laboratory)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.imaging) {
          <app-imaging-section
            [submenu]="getSubmenu(componentPaths.imaging)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.healthCarePlan) {
          <app-health-care-plan-section />
        }

        @if (activeSubmenu() == componentPaths.careTeam) {
          <app-care-team-section />
        }

        @if (activeSubmenu() == componentPaths.travelHistory) {
          <app-travel-history-section />
        }

        @if (activeSubmenu() == componentPaths.episodeOfCare) {
          <app-eoc-section [submenu]="getSubmenu(componentPaths.episodeOfCare)" />
        }

        @if (activeSubmenu() == componentPaths.tracheostomy) {
          <app-tracheostomy-section
            [submenu]="getSubmenu(componentPaths.tracheostomy)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.etiology) {
          <app-etiology-section />
        }

        @if (activeSubmenu() == componentPaths.capnography) {
          <app-capnography-section />
        }

        @if (activeSubmenu() == componentPaths.complication) {
          <app-complication-section />
        }

        @if (activeSubmenu() == componentPaths.comorbidity) {
          <app-comorbidity-section />
        }

        @if (activeSubmenu() == componentPaths.preciousAi) {
          <app-precious-ai [submenu]="getSubmenu(componentPaths.preciousAi)" />
        }

        @if (activeSubmenu() == componentPaths.patientCharacteristics) {
          <app-patient-characteristics />
        }

        @if (activeSubmenu() == componentPaths.initialAssessments) {
          <app-initial-assessment-amen-section
            [submenu]="getSubmenu(componentPaths.initialAssessments)"
            [(selectedOption)]="selectedOption"
          />
        }

        @if (activeSubmenu() == componentPaths.departmentalQuestionnaires) {
          <app-departmental-questionnaires-section
            [submenu]="getSubmenu(componentPaths.departmentalQuestionnaires)"
            [(selectedOption)]="selectedOption"
            [readonlyMode]="true"
          />
        }
        @if (activeSubmenu() == componentPaths.pilotQuestionnaires) {
          <app-pilot-questionnaires
            [submenu]="getSubmenu(componentPaths.pilotQuestionnaires)"
            [(selectedOption)]="selectedOption"
            [readonlyMode]="true"
          />
        }
        @if (activeSubmenu() == componentPaths.selfReport) {
          <app-self-report-section />
        }
      </nz-content>
    </nz-layout>
  </div>
</div>
}

@if (activeQuestionnaireScreen) {
  <div>
    <app-questionnaire-history-detail
      [embeddedMode]="true"
      [screenModeOverride]="activeQuestionnaireScreen.mode"
      [patientId]="patientID"
      [eocId]="eocID"
      [submissionId]="activeQuestionnaireScreen.questionnaireDataId"
      [questionnaireTemplateId]="activeQuestionnaireScreen.questionnaireTemplateId"
      (backRequested)="closeQuestionnaireScreen()"
    />
  </div>
}
